"use client";
import { FC } from "react";
import { Text, TextBig, TextMedium } from "../PrivacyPolicy/components/TextT";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

type Props = {
	data: any;
};

const TermOfUseScreen: FC<Props> = ({ data }) => {
	const prettyData = (data?.data ?? []).map((el: any) => el.attributes);
	const normalizeMargin = /\/normalize_margin\//;
	const regexDate = /^\/date_/;
	return (
		<div className='bg-main pt-[98px] pb-[20px] px-[80px] max-desktop:pt-[39px]  max-desktop:px-[33px] max-tablet:px-[16px]'>
			<div className='flex flex-col w-fit mr-auto'>
				<p className='text-[72px] leading-[80px]  max-desktop:text-[40px] tracking-[4.5px] max-tablet:tracking-[1px] font-bold  max-desktop:leading-[42px]'>
					WBTBRIDGE.COM – TERMS OF USE
				</p>
			</div>

			{prettyData.length === 0 && (
				<p className='text-[23px] max-desktop:text-[16px] text-white opacity-85 mt-[24px]'>
					Content unavailable.
				</p>
			)}
			{prettyData.map((el: any, index: number) => (
				<BlocksRenderer
					key={index}
					content={el.text}
					modifiers={{
						bold: ({ children }) => (
							<span className='font-[600]'>{children}</span>
						),
					}}
					blocks={{
						paragraph: ({ children }) => {
							//@ts-ignore
							if (children[0].props.text.match(regexDate)) {
								return (
									<p className='text-[35px] mt-[26px] font-[400] max-desktop:text-[20px] max-desktop:mt-[16px] '>
										{/*@ts-ignore */}
										{children[0].props.text.replace(regexDate, "")}
									</p>
								);
							}
							//@ts-ignore
							if (children[0].props.text.match(normalizeMargin)) {
								return <div className='mt-[-65px] max-desktop:mt-[-45px]' />;
							}
							return <Text>{children}</Text>;
						},
						heading: ({ children, level }) => {
							switch (level) {
								case 3:
									return <TextBig>{children}</TextBig>;
								case 4:
									return <TextMedium>{children}</TextMedium>;
								default:
									return <Text>{children}</Text>;
							}
						},
						list: ({ children }) => (
							<ul className='list-disc text-[35px] max-desktop:text-[20px] max-desktop:leading-[23px] leading-[34px] font-[300] pl-[35px] pt-[40px] max-desktop:pt-[26px]'>
								{/*@ts-ignore */}
								{children.map((el, index) => el)}
							</ul>
						),
					}}
				/>
			))}
		</div>
	);
};

export default TermOfUseScreen;

//            <TextBig>{t.b1}</TextBig>

//            <TextMedium>{t.m1}</TextMedium>

//            <Text>{t.t1}</Text>
